const isUserHasPermissions = ({ rolesAllowed, user }) => {
  if (!user) return false;
  if (!rolesAllowed?.length) return true;

  return !!rolesAllowed.filter(item => user[`${process.env.REACT_APP_BASE_URL}/roles`]?.includes(item))
    .length;
};

export default isUserHasPermissions;
